export class ObjectFieldLabel {
    Id: number;
    Tenant: number;
    ObjectFieldCode: string;
    ObjectTableCode: string;
    Label: string;
}